import { EventBasic } from './Event';
import { Member } from './Member';
import { registerSchema } from './transform';

export class EventDetails extends EventBasic {
  Details: string = '';
  Website: string = '';
  CreatedBy: Member | null = null;
  CreatorIsOrganizer: boolean = false;
  FollowersCount: number = 0;
  PhotoId: number | null = null;
  CanEdit: boolean = false;
  CanDelete: boolean = false;
  DateCreated: Date = new Date();
  PublicPhotosCount: number = 0;
  PostsCount: number = 0;
}

registerSchema(EventDetails, {
  StartDate: 'date',
  EndDate: 'date',
  DateCreated: 'date',
  CreatedBy: Member,
});
